import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image4 from "../../../../assets/images/Blog35/image4 US10Y range test.png";
import image19 from "../../../../assets/images/Blog35/image19 risk on is back.png";
import image2 from "../../../../assets/images/Blog35/image2 dotplot.png";
import image3 from "../../../../assets/images/Blog35/image3 hawkish dotplot ignored.png";
import image5 from "../../../../assets/images/Blog35/image5 CorePCE trend up.png";
import image7 from "../../../../assets/images/Blog35/image7 Atlanta GDP for Q3 flying.png";
import image8 from "../../../../assets/images/Blog35/image8 inflation tail risks.png";
import image16 from "../../../../assets/images/Blog35/image16 R2k op SPX.png";
import image17 from "../../../../assets/images/Blog35/image17 Nas100 uptrend may pause.png";
import image18 from "../../../../assets/images/Blog35/image18 NAs100 seasonality weak around here pre Oct.png";
import image14 from "../../../../assets/images/Blog35/image14 TMT AI record value.png";
import image23 from "../../../../assets/images/Blog35/image23 silver cup strong handle.png";
import image24 from "../../../../assets/images/Blog35/image24 gold close to a pause (1).png";
import image9 from "../../../../assets/images/Blog35/image9 LV recession risk1.png";
import image10 from "../../../../assets/images/Blog35/image10 Bond mkt recession risk2.png";
import image12 from "../../../../assets/images/Blog35/image12 ISM manu + chicago recession risk 3.png";
import image33 from "../../../../assets/images/Blog35/image33 US Global PMI.png";
import image30 from "../../../../assets/images/Blog35/image30 Growth does Trump Everything.png";
import BlogImagePopper from "./BlogImageLarge";

const Blog35 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – September 22nd, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Fed’s Policy Tightrope, Recession Rumbles, and AI Mega-Cap Dominance</p>
        <p>
          Markets head into the 39th week of 2025, historically the weakest week of the year, with a rare mix of dovish Fed expectations, growing recession fears, and relentless AI-driven market
          leadership.
        </p>
        <p>
          While indices continue their upward grind, traders face a complex landscape: rising stagflation concerns, looming government shutdown threats, and heightened seasonality risks. With October
          just ahead, the stage is set for either a consolidation phase or a volatile rotation across sectors.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview – “Uptrend With a Pause Button”</p>
              <p>
                US equities have “shot off into the sky” but are now brushing up against several headwinds — the government shutdown threat, US10Y yield spikes, and inflation creeping back into the
                stagflation narrative. Seasonality has been delayed all year, yet October looms as the likely month for consolidation. The parallels to Q4 2018 are striking — Trump wrestling with
                inflation optics and a softening jobs market even as tech carries the index weight.
              </p>
              <div className="relatedImg">
                <img
                  src={image4}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image4)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>
                Retail flows remain robust, but the real question is whether institutions are the marginal buyers or if the “risk-on” bid fades. The AI/commodities/value cyclicals trade remains
                dominant, but a multi-entry point setup is emerging for equity traders.
              </p>
              <div className="relatedImg">
                <img
                  src={image19}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image19)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Fed vs. Trump and the Third Mandate</p>
              <p>
                The Fed is attempting a high-wire act: delivering insurance cuts while inflation remains stubbornly elevated. The latest dot plot highlights the internal divide: one member called for
                a hike, another for a 50bps cut, and the rest split across a wide spectrum — the broadest policy divergence in years.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Economic signals remain mixed:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Core PCE </span>continues to trend higher, keeping inflation risk alive.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Atlanta GDPNow </span>suggests strong nominal growth despite soft patches in labour.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>Inflation tail risks remain a key concern for Q4.</p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image7}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image7)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image8}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Meanwhile, Trump is signalling warmer U.S.-China relations with the first U.S. House delegation to Beijing in six years, but the undertone remains protectionist with new visa fee hikes
                and persistent tariffs.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Indices at Their Limits</p>
              <p>Equity indices remain in uptrends but are stretched:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Russell 2000 (R2k) </span>outperformed SPX on rate-cut momentum, hitting its first new ATH since 2021.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">SPX valuation</span> now at 3.3x quarterly sales — the highest in history.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Nasdaq 100</span> is still trending up but showing early signs of exhaustion.
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image16}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image16)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image18}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image18)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                AI mega-caps dominate market cap: 109 AI stocks in the GS TMT basket are now worth <span className="highlightedText">$29.2 trillion,</span> nearly matching U.S. GDP. This concentration
                magnifies both upside and downside risk — if the “Mag 7” stumbles, the entire index structure could wobble.
              </p>
              <div className="relatedImg">
                <img
                  src={image14}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image14)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>
                Gold and silver have ripped higher since the August pivot. Silver broke out of a textbook cup-and-handle pattern while gold hovers near short-term resistance, hinting at potential
                profit-taking.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image23}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image23)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image24}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image24)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap – Fed Fallout, Rising Recession Signals, and Gold Strength</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">FOMC Dot Plot: </span>Turned more hawkish, even as markets priced in dovish outcomes.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Treasury Yields:</span> Jumped, with the dollar logging three straight days of gains.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold Rally: </span>Extended to five consecutive weeks, underscoring safe-haven demand.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Labour Market: </span> Disconnect between weakening job data and strong equity indices is widening.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Recession Indicators: </span> Longview, bond markets, and JOLTS data flash warnings of a potential mid-cycle downturn rather than a full
                    recession.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Global Developments: </span>
                  </p>
                  <ul style={{listStyleType: "disc", paddingLeft: "1rem"}}>
                    <li>
                      <p>BoJ announced earlier-than-expected plans to begin selling ETFs and JREITs, pressuring Japanese equities.</p>
                    </li>
                    <li>
                      <p>Japan’s leadership race and renewed U.S.-China diplomacy added political noise but no immediate market impact.</p>
                    </li>
                  </ul>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image12}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image12)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead – Light Data, Heavy Signals</p>

              <p className="highlightedText">Monday, September 22</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Positioning flows dominate, with limited data releases.</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, September 23</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Micron earnings – </span>critical read on semiconductors & AI hardware demand.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Treasury auction (2Y).</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, September 24</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    Speeches from
                    <span className="highlightedText"> Powell, Williams, Bostic, and Goolsbee –</span>tone could sway rate expectations.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>U.S. Treasury auction (5Y).</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, September 25</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Global PMIs –</span> key gauge for manufacturing weakness and rate cut pricing.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>U.S. Treasury auction (7Y).</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, September 26</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Final U.S. GDP reading –</span> expected to confirm stagflation setup.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Costco earnings –</span>retail demand snapshot heading into Q4.
                  </p>
                </li>
              </ul>
              <p className="highlightedText">Big Picture:</p>
              <p>
                It’s a light but pivotal week. With earnings thin and economic data limited, <span className="highlightedText">Fed speeches and bond auctions</span> will dominate trading flows. The
                setup favours tactical fades and disciplined positioning ahead of a heavier October calendar.
              </p>
              <div className="relatedImg">
                <img
                  src={image33}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image33)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway – Follow the Money, Respect the Pause</p>
              <p>Markets remain constructive, but the risk of October’s volatility looms large. This is a tactical environment — the goal is to trade levels, not chase trends blindly.</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span> <br></br> Indices are stretched with small caps leading, but Mag 7 concentration is a double-edged sword.Watch for rotations as
                    October seasonality kicks in.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span>
                    <br></br>Silver’s breakout remains bullish, but gold near $3,750 faces likely profit-taking in the near term.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro Focus:</span> <br></br>PCE data and Treasury auctions are this week’s quiet catalysts — surprises here can reset rate expectations quickly.
                  </p>
                </li>
              </ul>
              <p className="highlightedText">Bottom Line for Traders</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    Watch
                    <span className="highlightedText"> small caps vs. Mag 7</span> — they’ll set the market tone.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    Manage
                    <span className="highlightedText"> precious metals actively</span> as momentum slows.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>Stay tactical and nimble — this is a market built for fades, not conviction longs.</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image33}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image33)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image30}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image30)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image24}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image24)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1HeR3zsGKTmW0yvdDrF4h1pXXalRKJNlZhCAtvUO5khA/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog35;
